import styled from 'styled-components';

const getAccessor = (col) => {
  switch (col.name) {
    case 'prioritizedId':
      return 'displayId';
    case 'displayId':
      return 'displayId';
    case 'followers':
      return undefined;
    case 'resolutionTimer':
      return 'resolutionDueTimeLeft';
    default:
      return col.name;
  }
};

const getType = (col) => {
  if (col?.isCustom && col?.uiDataType === 'secure_text') {
    return 'SecureText';
  }
  switch (col.name) {
    case 'prioritizedId':
      return 'Priority';
    case 'requester':
    case 'technician':
    case 'techGroup':
      return 'Dual';
    case 'resolutionTimer':
      return 'Timer';
    case 'status':
      return 'Status';
    case 'subject':
      return 'HTML';
    case 'firstResponseDueTime':
    case 'resolutionDueTime':
    case 'firstResponseTime':
    case 'createdTime':
    case 'resolutionTime':
    case 'updatedTime':
      return 'DateTime';
    case 'cause':
    case 'subcause':
    case 'category':
    case 'subcategory':
    case 'issue':
    case 'subissue':
      return 'Dependant';
    // case 'taskSummary':
    //   return 'Progress'
    default:
      return 'Text';
  }
};

const getCellType = (col) => {
  switch (col.name) {
    case 'prioritizedId':
      return 'Priority';
    case 'technician':
    case 'techGroup':
      return 'Dual';
    case 'resolutionTimer':
      return 'Timer';
    case 'subject':
      return 'HTML';
    case 'firstResponseDueTime':
    case 'resolutionDueTime':
    case 'firstResponseTime':
    case 'createdTime':
    case 'resolutionTime':
    case 'updatedTime':
      return 'DateTime';
    case 'cause':
    case 'subcause':
    case 'category':
    case 'subcategory':
    case 'issue':
    case 'subissue':
      return 'Dependant';
    // case 'taskSummary':
    //   return 'Progress'
    default:
      return 'Text';
  }
};

const isEditable = (col) => {
  switch (col.name) {
    default:
      return false;
  }
};

const getTicketFields = (personalizedColumns) => {
  let fields = personalizedColumns.filter((el) => !el.isCustom);
  let fieldsToRequest = [
    {
      listInfo: ['page', 'pageSize', 'hasMore', 'totalCount']
    }
  ];
  let allFields = [];
  fields.forEach((el) => {
    switch (el.name) {
      case 'techGroup':
        allFields.push({
          techGroup: ['groupId', 'name']
        });
        break;
      case 'technician':
        allFields.push({
          technician: ['userId', 'email', 'firstName', 'lastName']
        });
        break;
      case 'client':
        allFields.push({
          client: ['name', 'accountId']
        });
        break;
      case 'requester':
        allFields.push({
          requester: ['firstName', 'lastName', 'userId', 'name']
        });
        break;
      case 'sla':
        allFields.push({
          sla: ['name']
        });
        break;
      case 'sop':
        allFields.push({
          sop: ['name']
        });
        break;
      case 'updatedTime':
        allFields.push('updatedTime');
        break;
      case 'approvals':
        break;
      case 'followers':
        allFields.push({
          followers: ['firstName', 'lastName', 'userId']
        });
        break;
      case 'additionalRequester':
        allFields.push({
          additionalRequester: ['firstName', 'lastName', 'userId']
        });
        break;
      case 'createdBy':
        allFields.push({
          createdBy: ['firstName', 'lastName', 'userId']
        });
        break;
      case 'resolutionTimer':
        allFields = allFields.concat([
          'resolutionDueTimeLeft',
          'resolutionDueTime',
          'resolutionTime'
        ]);
        break;
      case 'firstResponseTimer':
        allFields = allFields.concat([
          'firstResponseDueTimeLeft',
          'firstResponseDueTime',
          'firstResponseTime'
        ]);
        break;
      case 'department':
        allFields.push({
          department: ['businessFunctionId', 'name']
        });
        break;
      case 'site':
        allFields.push({
          site: ['name']
        });
        break;
      case 'displayId':
        allFields.push('displayId');
        break;
      case 'taskSummary':
        //   allFields = allFields.concat(['totalTasks', 'completedTasks']);
        break;
      case 'prioritizedId':
        allFields = allFields.concat(['priority', 'ticketType', 'displayId']);
        break;
      default:
        allFields.push(el.name);
    }
  });
  allFields = allFields.concat([
    'approverPermission',
    'followerPermission',
    'ticketId',
    'source',
    {
      latestReply: ['type', { user: ['userId', 'email'] }]
    },
    {
      client: ['name', 'accountId']
    }
  ]);
  if (personalizedColumns.length !== fields.length)
    allFields.push('customFields');
  fieldsToRequest.push({
    tickets: allFields
  });
  return fieldsToRequest;
};

const dependencyMap = {
  subcause: 'cause',
  subcategory: 'category',
  technician: 'techGroup',
  requester: 'client'
};

const isDependantField = (field) => {
  return Object.keys(dependencyMap).indexOf(field) > -1;
};

const getParentField = (child) => {
  return dependencyMap[child];
};

const getDependantField = (parent) => {
  return Object.keys(dependencyMap).find(
    (key) => dependencyMap[key] === parent
  );
};

const DisabledTag = styled.div`
  opacity: 0.5;
`;
const CellWrapper = styled.div`
  width: 100%;
  .Polaris-Link {
    width: 100%;
  }
`;

export {
  getAccessor,
  getType,
  getCellType,
  isEditable,
  getTicketFields,
  DisabledTag,
  dependencyMap,
  getDependantField,
  getParentField,
  isDependantField,
  CellWrapper
};
